import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as applicationActions from "../../actions/application";
import { APPLICATION_CONTEXTS } from "../../constants";
import VideoPlayer from "../common/videoPlayer";
// import DaddysHome from "./videos/DaddysHome.mp4";
// import LifeOfTheParty from "./videos/LifeOfTheParty.mp4";
// import SinginInTheRain from "./videos/SinginInTheRain.mp4";
// import TheGoodLiar from "./videos/TheGoodLiar.mp4";
import Rumble from "./videos/Rumble.mp4";
import ThorLoveAndThunder from "./videos/ThorLoveAndThunder.mp4";

class Video extends Component {
  /**************
   * Properties *
   **************/
  state = {
    baseUrl: "/movies/categories",
    videoNavigationBar: {
      mainMenu: false,
      back: false,
      backRoute: null,
      doGoBack: true,
    },
    videos: {
      action: ThorLoveAndThunder,
      kids: Rumble,
      // classics: SinginInTheRain,
      // comedy: DaddysHome,
      // drama: TheGoodLiar,
      // espanol: LifeOfTheParty,
    },
  };

  /*******************
   * Private methods *
   *******************/

  getCurrentMovieName = () => this.props.match.params.movieName;

  getCurrentCategoryName = () => this.props.match.params.categoryName;

  getVideo = () => {
    return {
      id: "moviesVideo",
      src: this.state.videos[this.getCurrentMovieName()],
    };
  };

  getBaseUrl = () => {
    if (this.props.location.state.baseUrl) {
      return this.props.location.state.baseUrl;
    } else {
      return this.state.baseUrl;
    }
  };

  getBackRoute() {
    let backRoute;
    if (this.props.match.params.categoryName === "main_menu") {
      backRoute = `/${this.props.match.params.categoryName}`;
    } else {
      backRoute = `${this.getBaseUrl()}/${
        this.props.match.params.categoryName
      }`;
      if (this.props.match.params.movieName) {
        backRoute += `/${this.props.match.params.movieName}`;
      }
    }
    return backRoute;
  }

  goBack = () =>
    this.props.history.push(this.getBackRoute(), {
      backPath: this.props.location.state.backPath || "",
    });

  handleOnKeyUp = (event) => {
    if (this.props.context !== APPLICATION_CONTEXTS.SERVICES) {
      return;
    }
    switch (event.key) {
      case "Enter":
      case "b":
      case "B":
        this.goBack();
        break;
      default:
    }
  };

  /*******************
   * Lifecycle hooks *
   *******************/

  /**
   * Performs various actions for component that will mount.
   *
   * This method will add a listener for the `keyup` event.
   *
   * @protected
   *
   **/
  componentWillMount() {
    document.addEventListener("keyup", this.handleOnKeyUp, false);
  }

  /**
   * Performs various actions for component that will unmount.
   *
   * This method will remove the listener for the `keyup` event.
   *
   * @protected
   *
   **/
  componentWillUnmount() {
    document.removeEventListener("keyup", this.handleOnKeyUp);
  }

  /******************
   * Public methods *
   ******************/

  /**
   * Renders the component.
   *
   * @public
   *
   * @returns {React.Component}  The rendered view of the component.
   *
   **/
  render() {
    return (
      <VideoPlayer
        {...this.getVideo()}
        navigationBar={this.state.videoNavigationBar}
      />
    );
  }
}

const ConnectedVideo = connect(
  (state) => ({
    context: state.application.currentContext,
  }),
  (dispatch) => ({
    actions: bindActionCreators(
      {
        ...applicationActions,
      },
      dispatch
    ),
  })
)(Video);

export default withRouter(ConnectedVideo);
